import { Injectable } from '@angular/core';
import { CatalogServices } from './catalogServices';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class RepresentanteServices{
  
  static currentVisitador: any;
  
  private sCurrentVisita: Subject<any>=new Subject<any>();
  
  constructor(private catalogServices:CatalogServices){}
  
  onCurrentVisitaSet():Observable<any>{
    return this.sCurrentVisita.asObservable();
  }
  setCurrentVisita(me){
    if(me && me.lineas)
      this.sCurrentVisita.next(me);
  }
  setcurrentVisitador(){
    RepresentanteServices.currentVisitador = this.catalogServices.getCatalogByName("infoVisitador");
  }
}


